import { Box } from '@mui/material';

export const MRD = () => {
  return <Box sx={{ flex: 1 }}></Box>;
};
